export enum CellValueTheme {
  Secondary = 'secondary',
  Tertiary = 'tertiary',
}
